@use '../../custom-scroll/custom-scroll' as *;
@use '../../tanstack-table/tanstack-table' as *;
@use '../../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .container {
    flex: 1;
    width: 100%;
    height: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
  }

  .cellWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: var(--text-default);

    &[data-price-status='negative'] {
      color: var(--viz-bearish);
    }

    &[data-price-status='positive'] {
      color: var(--viz-bullish);
    }

    &[data-status='Success'] {
      padding: 2px 8px;
      border-radius: border-radius(r1);
      color: var(--viz-bullish);
      background-color: var(--viz-bullish-soft);
    }

    &[data-status='Failed'] {
      padding: 2px 8px;
      border-radius: border-radius(r1);
      color: var(--viz-bearish);
      background-color: var(--viz-bearish-soft);
    }
  }

  .cellInner {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: max-content;

    img {
      border-radius: border-radius(full);
      width: 20px;
      height: 20px;
      overflow: hidden;
    }
  }

  .wrapper {
    overflow: auto;
    @include custom-scroll-minimal;
    width: 100%;
    position: relative;
    border-radius: border-radius(r2);
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top: none;

    &[data-show-border='true'] {
      border: 1px solid var(--border-soft);
      border-top: none;
    }
  }

  .styledTanStackTableRoot {
    @include tanstack-table-root;
    position: relative;
    border-radius: border-radius(r2);
    width: 100%;
    max-width: 100%;

    thead {
      width: 100%;
      table-layout: fixed;

      th {
        min-width: 116px;
      }
    }

    td {
      padding: 12px;
      min-width: 148px;
    }

    &[data-custom-header='true'] td {
      padding: 6px 12px;
    }

    tbody tr {
      width: 100%;
      table-layout: fixed;

      td {
        min-width: 116px;
      }
    }
  }

  .buttonWrapper {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
  }
}
